import React from "react"

const Twitter = () => {
  return (
    <svg width="29px" height="24px" viewBox="0 0 29 24">
      <title>Twitter</title>
      <defs>
        <polygon id="path-1" points="0.00012 0 28.8012 0 28.8012 23.40816 0.00012 23.40816"></polygon>
      </defs>
      <g id="D2:-Sun-Up-Sun-Down" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Bio---Sun-Up" transform="translate(-268.000000, -1221.000000)">
          <g id="Twitter" transform="translate(268.000000, 1221.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
          <g id="Clip-2"></g>
          <path d="M28.74492,2.78736 C27.68292,3.25416 26.54892,3.57216 25.35492,3.71736 C26.57052,2.98416 27.50772,1.82856 27.95052,0.44976 C26.80932,1.11576 25.54452,1.60056 24.19812,1.87056 C23.12172,0.71976 21.59052,-0.00024 19.88892,-0.00024 C16.62852,-0.00024 13.98492,2.64336 13.98492,5.90016 C13.98492,6.36816 14.03892,6.81816 14.13732,7.24896 C9.22932,7.01736 4.87932,4.66056 1.96812,1.09776 C1.45572,1.96416 1.16892,2.97096 1.16892,4.06776 C1.16892,6.11976 2.21292,7.92336 3.79452,8.98296 C2.82612,8.95176 1.91532,8.68536 1.12092,8.24376 L1.12092,8.31696 C1.12092,11.17896 3.15252,13.56576 5.85612,14.10936 C5.36052,14.24256 4.83732,14.31456 4.30092,14.31456 C3.92412,14.31456 3.56292,14.27856 3.20172,14.21136 C3.95892,16.55496 6.13572,18.26376 8.72652,18.31176 C6.71052,19.89456 4.15572,20.83776 1.40412,20.83776 C0.93612,20.83776 0.46932,20.81016 0.00012,20.75736 C2.62692,22.43136 5.72172,23.40816 9.06852,23.40816 C19.93332,23.40816 25.86732,14.41296 25.86732,6.62496 C25.86732,6.37416 25.86732,6.12096 25.84932,5.86896 C27.00252,5.04216 28.00932,3.99696 28.80132,2.81136 L28.74492,2.78736 Z" id="Fill-1" fill="#000000" mask="url(#mask-2)"></path>
        </g>
      </g>
    </g>
  </svg>
  )
}

export default Twitter
